import { useEffect, useState } from "react";
import { deleteClientes, getClientes } from "../../services/ClientesServices";
import { ClienteContext } from "./ClienteContext"


export const ClienteState = ({ children }) => {
    const [data, setData] = useState()

    useEffect(() => {
        getClienteData()
    }, [])


    const getClienteData = async () => {
        let res = await getClientes()
        if (res) setData(res)
    }

    const deleteClienteData = async (body) => {
        const res = await deleteClientes(body)
        if (res) getClienteData()
        return res
    }


    return <ClienteContext.Provider value={{
        data,
        deleteClienteData,
        getClienteData
    }} >
        {children}
    </ClienteContext.Provider>
}